import React, { useEffect } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

export default function EC_Modal({
  isOpen,
  children,
  closeModal,
  title,
  styleTop,
  styleLeft,
  styleUnit,
}) {
  let styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#11101b",
      // backgroundImage: "#12101c",
      height: "max-content",
      width: "max-content",
      maxWidth: "75%",
      maxHeight: "75%",
      borderRadius: "1rem",
      padding: "10px",
      overflow: "auto",
      border:"1px solid rgba(124, 92, 255, 0.6)",
    },
    overlay: { backgroundColor: 'rgba(0, 0, 0, 0.55)' }
  };
  if (styleTop) {
    styleModel.content.top = styleTop + (styleUnit || "%");
  }
  if (styleLeft) {
    styleModel.content.left = styleLeft + (styleUnit || "%");
  }
  useEffect(() => {
    const handleKeydown = (e) => {
      if (isOpen && e.key === "Enter") {
        closeModal();
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeydown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [isOpen, closeModal]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={styleModel}
      className="ecModal"
    >
      <div >
        <div
          className="border-b FontFamily-Avenir text-xl flex justify-between text-white p-2 pr-4"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            
          }}
        >
          <span className="text-lg manrope-800">{title}</span>
          <span className="text-lg manrope-400 hover:bg-red-400/10 hover:border-red-400/20" onClick={closeModal} style={{color: "white", cursor: "pointer",  textAlign:'center', borderRadius: '50%', padding: '3px 10px' }}>
          &#10005;
          </span>
        </div>
        <div>{children}</div>
      </div>
    </Modal>
  );
}
